import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Btn, Field, Modal } from "@/components/rp";

export const ChangePassword = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ old_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (f.new_password !== f.confirm) { toast.error("Le due password nuove non coincidono"); return; }
    setBusy(true);
    try { await api.post("/auth/change-password", { old_password: f.old_password, new_password: f.new_password }); toast.success("Password aggiornata"); setOpen(false); setF({ old_password: "", new_password: "", confirm: "" }); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className={`flex items-center gap-2 text-sm text-[#757575] hover:text-black transition-colors ${className}`} data-testid="change-password-open">
        <KeyRound className="h-4 w-4" /> Cambia password
      </button>
      <Modal open={open} onOpenChange={setOpen} title="Cambia password" description="Scegli una password di almeno 8 caratteri." testid="change-password-dialog">
        <div className="space-y-3">
          <Field label="Password attuale"><input type="password" value={f.old_password} onChange={(e) => setF({ ...f, old_password: e.target.value })} className="rp-field" data-testid="change-password-old" /></Field>
          <Field label="Nuova password"><input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className="rp-field" data-testid="change-password-new" /></Field>
          <Field label="Ripeti la nuova password"><input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="rp-field" data-testid="change-password-confirm" /></Field>
          <Btn loading={busy} disabled={!f.old_password || f.new_password.length < 8} onClick={save} data-testid="change-password-save">Salva la nuova password</Btn>
        </div>
      </Modal>
    </>
  );
};
